{
  "it": {
    "session": {
      "error_internalserver": {
        "goback": "Torna indietro",
        "subtitle": "Ops, sembra che si sia verificato un errore imprevisto.",
        "title": "500"
      },
      "error_notfound": {
        "goback": "Torna indietro",
        "subtitle": "Siamo spiacenti, la pagina che sta cercando non è stata trovata.",
        "title": "404"
      },
      "expired": {
        "text": "La Sua sessione è scaduta per inattività. Per motivi di sicurezza, deve effettuare nuovamente l'accesso. \n\nFaccia clic su OK per essere reindirizzato alla schermata di accesso.",
        "title": "Sessione scaduta"
      },
      "logout_impersonate": {
        "text": "È stata attivata un'azione di disconnessione durante l'impersonificazione.",
        "title": "Impersonificazione interrotta"
      },
      "noaccess": {
        "text": "Potrebbe essere interessato dal nostro <b>aggiornamento</b> più recente: <p></p> <ul> <li>&nbsp;</li> <li><b>I membri del team e i partner</b> ora hanno accesso (e possono accedere) tramite <b>ziggu.app</b> (invece di <i>%company%</i>.ziggu.app)</li> <li>&nbsp;</li> <li><b>I clienti</b> non sono interessati e possono ancora accedere alla piattaforma tramite <b><i>%company%</i>.ziggu.app</b> </ul> <p>&nbsp;</p> <p>Facendo clic su OK sarà reindirizzato alla pagina appropriata.</p> <p>Se continua a riscontrare problemi, ci contatti.</p>",
        "title": "Ops… non sembra avere (più) accesso a questa pagina."
      }
    }
  }
}
